var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "M3.611 8.333H3.61a.42.42 0 0 1-.369-.225C2.656 6.978 2 6.058 1.234 5.295a.416.416 0 1 1 .59-.59 11.4 11.4 0 0 1 1.789 2.349C4.87 4.864 6.42 3.082 8.226 1.749a.417.417 0 0 1 .495.67C6.836 3.811 5.24 5.726 3.98 8.112a.42.42 0 0 1-.368.222z"
  })));
};
export default SvgCheckMark;